import React, { useEffect, useContext } from 'react';
import styles from '@styles/home.module.css';
import { withNamespaces } from 'react-i18next';
import Greetings from '@components/home/Greetings'
import { makeStyles } from '@material-ui/core/styles';
import { AppContext } from '@/AppContext';
import { GetWorksiteDescription } from '@utils/accessTypeHelper';
import { Company, Worksite } from '@users';
import * as storage from '@storage';

const useStyles = makeStyles((theme) => ({
    divRootHome: {
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: '-webkit-center'
    },
    divRootGreetings: {
        margin: '0',
        width: '100%',
        borderRadius: 'unset',
        boxShadow: 'none',
        color: 'var(--color1)',
        borderBottom: '1px solid #d3d3d399',
        position: 'static'
    },
}));


function HomeContent(props) {
    const classes = useStyles();
    const { setDescWorksite, setShowBarDesc } = useContext(AppContext);

    useEffect(() => {
        loadWorksiteContext();
        resize();
    }, []);

    const loadWorksiteContext = () => {
        // I had to do that here because when logged in the app does a redirect and that set the context to null
        const company = Company();
        const worksite = Worksite();
        const worksites = storage.getWorksites();

        setDescWorksite(GetWorksiteDescription(company, worksite, worksites));
        setShowBarDesc(true);
    }

    const resize = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const divMenu = document.querySelector('#menuFavorite').clientHeight;
            const divGreetings = document.querySelector('#divGreetings')?.clientHeight;
            const offSet = 0;

            const customHeight = height - titleBar - divMenu - divGreetings - offSet;

            const element = document.querySelector('#divRootHome');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 1000);
    }

    return (
        <div>
            <div id={"divGreetings"} className={`${styles.contentType} ${classes.divRootGreetings}`}>
                <div style={{ maxWidth: "700px", width: "calc(100% - 30px)", display: "inline-block" }}>
                    <Greetings />
                </div>
            </div>
            <div id={"divRootHome"} className={`${styles.contentRoot} ${classes.divRootHome}`}>
            </div>
        </div>
    );
}
export default withNamespaces(['HomeContent', 'error', 'accessType'], { wait: true })(HomeContent);